<script>
export default {
  name: 'TotalBlockRow',
  components: {},
  props: {
    label: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      
    };
  },
  computed: {
    
  },
  watch: {},
  mounted() {
    
  },
  methods: {
    
  }
}
</script>

<template>
  <div class="row flex justify-between align-end">
    <div class="flex align-end" style="width: 100%;">
      <div v-if="label" class="title">{{ label }}</div>
      <div class="items flex align-end gap-xxl">
        <slot name="default"></slot>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.row {
  width: 100%;

  .title {
    min-width: 100px;
    color: var(--color-text-1);
  }
  .items {
    width: 100%;
    // &>* {
    //   min-width: 200px;
    // }
    // &>*:not(:last-child) {
    //   margin-right: 20px;
    // }
  }
}
</style>